export default __webpack_public_path__ + "static/media/ghst.f7d40e6f.svg";